import React, { useRef, useMemo, useEffect } from "react";
import { useState } from "react";
import Adsense from "../../../Reusable/Adsense/Adsense.js";
import FolderDivider from "./FolderDivider.js";
import { debounce } from "lodash";

const GridItemContainer = ({ children, item, width, alwaysShow }) => {
  const [show, setShow] = useState(true);

  // onscroll function to detect when item is in view by item.posY property
  const onScroll = () => {
    const viewPointStart = window.scrollY;
    const viewPointEnd = viewPointStart + window.innerHeight;
    const containerTopPosition =
      document.querySelector(".grid-holder")?.offsetTop;
    const itemPosition = item.posY + containerTopPosition;
    const isItemInViewport =
      itemPosition > viewPointStart - window.innerHeight / 2 &&
      itemPosition < viewPointEnd + window.innerHeight / 2;

    if (isItemInViewport) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const debaunceOnScroll = debounce(onScroll, 100);

  // onscroll event listener
  useEffect(() => {
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [item.posY]);

  // check view on resize
  useEffect(() => {
    onScroll();
  }, [width]);

  const classNames = useMemo(() => {
    return `cool-grid-item ${
      item.id.indexOf("folder") > -1 ? "cool-grid-folder-divider" : ""
    }`;
  }, [item]);

  if (item.id.indexOf("ad") > -1)
    return (
      <div style={item.style} key={item.id} className={"cool-grid-item"}>
        <Adsense
          bannerPosition="download-thumbnail-display"
          size={{ width: item.style.width, height: item.style.height }}
        />
      </div>
    );

  return (alwaysShow || show) ? (
    <div style={item.style} className={classNames}>
      {item.id.indexOf("folder") > -1 ? (
        <FolderDivider itemId={item.id} />
      ) : (
        children
      )}
    </div>
  ) : null;
};

const checkToRerender = (prev, next) => {
  return JSON.stringify(prev.item.style) === JSON.stringify(next.item.style);
};
export default React.memo(GridItemContainer, checkToRerender);
